// @flow

import request from 'pages/MyAccount/services/api/request';
import env from 'pages/MyAccount/utils/env';
import type { AbTestResponse } from 'pages/MyAccount/sharedTypes';

export function getGwpTest(): Promise<AbTestResponse> {
  const requestUrl = `${env.abTestPath}/variants/self/preselected?testId=${env.abTestGwpId}`;
  return request(requestUrl);
}
